import produce from "immer";
import React, { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { startEditElement } from "../../../../../actions/elementListAction";
import { Element } from "../../../../../models/elementModel";
import "react-tippy/dist/tippy.css";
import { Tooltip } from "react-tippy";
import ActionListComponent from "../../../../utilComponents/actionListComponent/actionListComponent";
import { getSession } from "../../../../../selectors/appSelectors";
import { SystemTypes } from "../../../../../utils/constants";
import "../../Remarks.scss";

export interface RenderInputElementProps {
  index: string;
  element: Element;
  isPreview?: boolean;
}

const RenderInputElement: FC<RenderInputElementProps> = ({
  index,
  element,
  isPreview,
}) => {
  const dispatch = useDispatch();
  const sessionState = useSelector(getSession);
  const [actionPanelStatus, setActionPanelStatus] = useState(false);
  const [viewPassword, setViewPassword] = useState(false);
  const [viewRemark, setViewRemark] = useState(sessionState.viewRemark);
  const inputClassName = `was-validated ${
    element.properties.type === "password" ? "input-group" : "form-group"
  }`;

  const [open, setIsOpen] = useState(false);

  useEffect(() => {
    setViewRemark(sessionState.viewRemark);
  }, [sessionState]);

  const defaultStyle = {
    marginTop: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginTop + "px",
    marginRight: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginRight + "px",
    marginBottom: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginBottom + "px",
    marginLeft: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginLeft + "px",
    textAlign: element.styles.textAlign
  };
  //custome css - start
  const styleList = element.properties.cssStyles;

  const styleObj: { [key: string]: any } = {};

  for (let index = 0; index < styleList.length; index++) {
    styleObj[styleList[index].retrivedStyle] = styleList[index].value;
  }
  //custome css - end

  return (
    <>
      <Tooltip title={element.properties.tooltip}>
        <div key={index} className={inputClassName} style={{ ...defaultStyle }}>
          <input
            id={`${element.id}`}
            type={viewPassword ? "text" : element.properties.type}
            className={`${element.properties.className} ${
              element.properties.display === false && !isPreview
                ? "blur-element"
                : ""
            }`}
            placeholder={element.properties.placeholder}
            style={{
              height:
                element.styles.height === "" ||
                element.styles.height === undefined ||
                element.styles.height === "0"
                  ? ""
                  : element.styles.height + "px",
              width:
                element.styles.width === "" ||
                element.styles.width === undefined ||
                element.styles.width === "0"
                  ? ""
                  : element.styles.width + "px",
              fontSize:
                element.styles.fontSize === "" ||
                element.styles.fontSize === undefined ||
                element.styles.fontSize === "0"
                  ? ""
                  : element.styles.fontSize + "pt",
              color: element.styles.color,
              ...styleObj,
            }}
            required={element.properties.required}
            disabled={element.properties.disabled}
            // value={element.properties.value}
            // onChange={(e) => {
            // //   if (isPreview === false) {
            //     const newElement = produce(element, (draft) => {
            //       draft.properties.value = e.target.value;
            //     });
            //     dispatch(startEditElement(newElement));
            //   // }
            // }}
            onClick={() => {
              setActionPanelStatus(!actionPanelStatus);
            }}
          />
          {element.properties.type === "password" && (
            <button
              className="btn btn-outline-secondary"
              type="button"
              onMouseDown={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setViewPassword(true);
              }}
              onMouseUp={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setViewPassword(false);
              }}
            >
              <i className="fa fa-eye-slash" aria-hidden="true"></i>
            </button>
          )}
          {/* {element.properties.type === "password" && (
        <div className="input-group-append">

        </div>
      )} */}
          {element.properties.required && (
            <div className="valid-feedback">
              {element.properties.valid_feedback}
            </div>
          )}
          {element.properties.required && (
            <div className="invalid-feedback">
              {element.properties.invalid_feedback}
            </div>
          )}
          {/* {(sessionState.selectedType === SystemTypes.ELEMENT && sessionState.selectedElementId === element.id) && (
         <div className="action-list-panel">
         <ActionListComponent type="element" element={element}/>
       </div>
      )} */}
        </div>
      </Tooltip>
      {isPreview &&
        viewRemark &&
        (element.properties.remark1 ||
          element.properties.remark2 ||
          element.properties.remark3 ||
          element.properties.remark4) && (
          <Tooltip
            interactive
            open={open}
            onRequestClose={() => setIsOpen(false)}
            html={
              <>
                <h6>Remarks of {element.name}</h6>
                {element.properties.remark1 !== undefined &&
                  element.properties.remark1 !== "" && (
                    <div className="remark">
                      Remark 1 : {element.properties.remark1}
                    </div>
                  )}
                {element.properties.remark2 !== undefined &&
                  element.properties.remark2 !== "" && (
                    <div className="remark">
                      Remark 2 : {element.properties.remark2}
                    </div>
                  )}
                {element.properties.remark3 !== undefined &&
                  element.properties.remark3 !== "" && (
                    <div className="remark">
                      Remark 3 : {element.properties.remark3}
                    </div>
                  )}
                {element.properties.remark4 !== undefined &&
                  element.properties.remark4 !== "" && (
                    <div className="remark">
                      Remark 4 : {element.properties.remark4}
                    </div>
                  )}
                {(element.properties.remark1 === undefined ||
                  element.properties.remark1 === "") &&
                  (element.properties.remark2 === undefined ||
                    element.properties.remark2 === "") &&
                  (element.properties.remark3 === undefined ||
                    element.properties.remark3 === "") &&
                  (element.properties.remark4 === undefined ||
                    element.properties.remark4 === "") && (
                    <div>No Remarks to Display</div>
                  )}
              </>
            }
            position="left"
          >
            <div style={{ textAlign: "end" }}>
              <i
                className="fa fa-info-circle"
                aria-hidden="true"
                onClick={() => {
                  setIsOpen(true);
                }}
              ></i>
            </div>
          </Tooltip>
        )}
    </>
  );
};

export default RenderInputElement;
